import React from 'react';
import { CookieSettingsLink } from './CookieConsentBanner';

const Footer: React.FC = () => {
  return (
    <footer className="text-center mb-4">
      <div className="text-gray-500 text-sm">
        <p>&copy; {new Date().getFullYear()} AACore Booking. All rights reserved.</p>
        <p className="mt-1">
          Powered by <a href="https://booking.aacore.net" target="_blank" rel="noopener noreferrer" className="text-blue-900 hover:text-blue-800 hover:underline">AACore</a> • Built by <a href="https://aainomatic.com" target="_blank" rel="noopener noreferrer" className="text-blue-900 hover:text-blue-800 hover:underline">A&A Inomatic</a>
          {' '}• <a href="/privacy" className="text-blue-900 hover:text-blue-800 hover:underline">Privacy Policy</a>
          {' '}• <CookieSettingsLink />
        </p>
      </div>
    </footer>
  );
};

export default Footer;

